import { useMask } from '@react-input/mask'
import { KTextField, KTextFieldProps } from 'components/core/KTextField'
import { ForwardRefExoticComponent, RefAttributes, forwardRef } from 'react'

interface KCreditCardValidThruFieldProps
  extends Omit<KTextFieldProps, 'type' | 'onKeyDown'> {}

export const KCreditCardValidThruField: ForwardRefExoticComponent<
  Omit<KCreditCardValidThruFieldProps, 'ref'> & RefAttributes<HTMLDivElement>
> = forwardRef((props, ref) => {
  const { sx, ...restProps } = props
  const inputRef = useMask({
    mask: '__/__',
    replacement: { _: /\d/ },
    showMask: true,
  })

  return (
    <KTextField
      ref={ref}
      inputRef={inputRef}
      {...restProps}
      sx={{ '& input': { textAlign: 'center' }, ...sx }}
    />
  )
})
